var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-rate',{attrs:{"value":_vm.star / 20,"allowHalf":"","disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }